var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { Button, FFAsyncDropdown, FFTextInput, GBTypography } from '@leapfinance/geebee-component-library';
import { IconButton } from '@mui/material';
import classNames from 'classnames';
import { AddIcon, DeleteIcon } from './icons';
var CreateOrSearchStudentField = function (_a) {
    var studentFieldProps = _a.studentFieldProps, studentcomponentProps = _a.studentcomponentProps, firstNameFieldProps = _a.firstNameFieldProps, firstNameComponentProps = _a.firstNameComponentProps, lastNameFieldProps = _a.lastNameFieldProps, lastNameComponentProps = _a.lastNameComponentProps, studentCreateModeDefaultValue = _a.studentCreateModeDefaultValue, addStudentLabelButtonProps = _a.addStudentLabelButtonProps, addStudentIconProps = _a.addStudentIconProps, onCreateStudentClick = _a.onCreateStudentClick, onDeleteStudent = _a.onDeleteStudent, _b = _a.column, column = _b === void 0 ? false : _b, _c = _a.hideCreateStudentHeader, hideCreateStudentHeader = _c === void 0 ? false : _c;
    var _d = __read(useState(false), 2), showCreateNewStudent = _d[0], setShowCreateNewStudent = _d[1];
    useEffect(function () {
        setShowCreateNewStudent(studentCreateModeDefaultValue !== null && studentCreateModeDefaultValue !== void 0 ? studentCreateModeDefaultValue : false);
    }, [studentCreateModeDefaultValue]);
    return (React.createElement("div", null, showCreateNewStudent ? (React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-[0.38rem] lfc-w-full" },
        !hideCreateStudentHeader && (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-justify-between" },
            React.createElement(GBTypography, { variant: "sh2Semibold", className: "lfc-text-black" }, "Create student"),
            React.createElement(IconButton, { onClick: function () {
                    setShowCreateNewStudent(false);
                    onCreateStudentClick === null || onCreateStudentClick === void 0 ? void 0 : onCreateStudentClick('no');
                    onDeleteStudent === null || onDeleteStudent === void 0 ? void 0 : onDeleteStudent();
                } },
                React.createElement(DeleteIcon, { className: "lfc-w-[1.125rem] lfc-h-[1.125rem]" })))),
        React.createElement("div", { className: classNames('lfc-flex lfc-items-start lfc-gap-x-2 lfc-w-full', {
                'lfc-flex-col lfc-gap-3': column
            }) },
            React.createElement("div", { className: "lfc-flex-1 lfc-w-full" },
                React.createElement(FFTextInput, { fieldProps: __assign({}, firstNameFieldProps), componentProps: __assign({ label: 'First Name', placeholder: 'Enter First name' }, firstNameComponentProps) })),
            React.createElement("div", { className: "lfc-flex-1 lfc-w-full" },
                React.createElement(FFTextInput, { fieldProps: __assign({}, lastNameFieldProps), componentProps: __assign({ label: 'Last Name', placeholder: 'Enter Last name' }, lastNameComponentProps) }))))) : (React.createElement("div", null,
        React.createElement(FFAsyncDropdown, { fieldProps: __assign({}, studentFieldProps), componentProps: __assign(__assign({}, studentcomponentProps), { textInputProps: __assign({ label: (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-justify-between" },
                        React.createElement(GBTypography, { variant: "sh2Semibold", className: "lfc-text-black" },
                            "Select student ",
                            React.createElement("span", { className: "lfc-text-gbTokens-error-500" }, "*")),
                        React.createElement(Button, __assign({ variant: "tertiary", className: "lfc-text-primary-500", size: "small", startIcon: React.createElement(AddIcon, __assign({}, addStudentIconProps)), onClick: function () {
                                onCreateStudentClick === null || onCreateStudentClick === void 0 ? void 0 : onCreateStudentClick('yes');
                                setShowCreateNewStudent(true);
                            } }, addStudentLabelButtonProps), "Add Student"))) }, studentcomponentProps === null || studentcomponentProps === void 0 ? void 0 : studentcomponentProps.textInputProps) }) })))));
};
export default CreateOrSearchStudentField;
//# sourceMappingURL=CreateOrSearchStudent.js.map